import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './components/LanguageContext';
import { WelcomePage } from './components/WelcomePage';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FreeInspectionPage } from './pages/FreeInspectionPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { ServiceDetailPage } from './pages/ServiceDetailPage';
import { ConsultationPage } from './pages/ConsultationPage';
function HomePage() {
  return <>
      <Hero data-id="element-0" />
      <Services data-id="element-1" />
      <WhyChooseUs data-id="element-2" />
      <Process data-id="element-3" />
      <Testimonials data-id="element-4" />
      <Contact data-id="element-5" />
    </>;
}
function MainSite() {
  const {
    hasSelected
  } = useLanguage();
  if (!hasSelected) {
    return <WelcomePage data-id="element-6" />;
  }
  return <div className="min-h-screen bg-gray-900 font-sans selection:bg-brand-red selection:text-white" data-id="element-7">
      <Navbar data-id="element-8" />
      <main data-id="element-9">
        <Routes data-id="element-10">
          <Route path="/" element={<HomePage data-id="element-12" />} data-id="element-11" />
          <Route path="/free-inspection" element={<FreeInspectionPage data-id="element-14" />} data-id="element-13" />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-16" />} data-id="element-15" />
          <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-18" />} data-id="element-17" />
          <Route path="/services/:slug" element={<ServiceDetailPage data-id="element-20" />} data-id="element-19" />
          <Route path="/consultation" element={<ConsultationPage data-id="element-22" />} data-id="element-21" />
        </Routes>
      </main>
      <Footer data-id="element-23" />
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-24">
      <MainSite data-id="element-25" />
    </LanguageProvider>;
}